import identityReducer from '../common/identity-reducer';

import {editStoreAction} from "./actions";

const storeReducer = identityReducer.bind(editStoreAction.getIdentityReducerThisObj());

export default ({
    postStoreResult: storeReducer
});